var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import styles from './Spinner.module.scss';
/**
 * @tdr
 */
export var Spinner = function (_a) {
    var _b;
    var _c = _a.ariaTextActive, ariaTextActive = _c === void 0 ? 'Loading' : _c, ariaTextInactive = _a.ariaTextInactive, className = _a.className, isActive = _a.isActive, _d = _a.pageSpinner, pageSpinner = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.theme, theme = _f === void 0 ? 'dark' : _f, props = __rest(_a, ["ariaTextActive", "ariaTextInactive", "className", "isActive", "pageSpinner", "size", "theme"]);
    return (React.createElement(React.Fragment, null,
        ((isActive && ariaTextActive) || (!isActive && ariaTextInactive)) && (React.createElement("div", { role: "status", "aria-live": "polite", className: styles.srOnly }, isActive ? ariaTextActive : ariaTextInactive)),
        isActive && (React.createElement(React.Fragment, null,
            React.createElement("div", __assign({ className: classNames((_b = {}, _b[styles.pageSpinner] = pageSpinner, _b), className), "data-test": "spinner" }, props),
                React.createElement("div", { "aria-hidden": "true", className: classNames(styles.spinner, styles[size], styles[theme]) },
                    React.createElement("div", { className: styles.spinnerAnimation }),
                    React.createElement("div", { className: styles.spinnerAnimation }),
                    React.createElement("div", { className: styles.spinnerAnimation }),
                    React.createElement("div", { className: styles.spinnerAnimation })))))));
};
//# sourceMappingURL=Spinner.js.map